import React from "react";
import { XCircle } from "lucide-react";

export interface OrderItem {
  id: string;
  name: string;
  selling_price: number;
  quantity: number;
  total_quantity: number;
}

interface Props {
  item: OrderItem;
  onQuantityChange: (id: string, newQty: number) => void;
  onRemove: (id: string) => void;
}

const OrderItemRow: React.FC<Props> = ({ item, onQuantityChange, onRemove }) => {
  return (
    <div className="flex justify-between items-center py-3 px-2 border-b">
      <div className="flex flex-col text-left">
        <span className="font-semibold">{item.name}</span>
        <span className="text-xs text-gray-500">₵{item.selling_price} each</span>
      </div>
      <div className="flex items-center gap-2">
        <input
          type="number"
          min={1}
          max={item.total_quantity}
          value={item.quantity}
          onChange={(e) =>
            onQuantityChange(item.id, Math.min(item.total_quantity, Number(e.target.value)))
          }
          className="w-16 border rounded-md px-2 py-1 text-sm text-center"
        />
        <span className="text-gray-600">₵{item.selling_price * item.quantity}</span>
        <button onClick={() => onRemove(item.id)} className="text-red-600 hover:text-red-800">
          <XCircle color="red" size={16} />
        </button>
      </div>
    </div>
  );
};

export default OrderItemRow;
